<header class="site-header desktop-only">
  <div class="top-bar">
    <div class="container container-desktop top-content">
      <a href="mailto:demandes-clients@cavernedugobelin.fr" class="contact-link">
        <span class="icone">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
        </span>
        <span class="text-hide-mobile">Contactez-nous</span>
      </a>
      <app-search-bar></app-search-bar>
      <div class="right-links">
        <div class="cart-link-top" [routerLink]="route.get('cart')" style="cursor: pointer;">
          <span class="icone">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
          </span>
          <span class="text-hide-mobile">Mon panier</span>
          <span class="badge-white-inline" *ngIf="cart.count() > 0">{{ cart.count() }}</span>
        </div>

        <div class="login-link" [routerLink]="route.get('login')" *ngIf="!isUserConnected()">
          <span class="icone"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg></span>
          <span class="text-hide-mobile">Se connecter</span>
        </div>
        <div class="account-link" [routerLink]="isAdmin ? route.get('my-account') : route.get('admin-home')" *ngIf="isUserConnected()">
          <span class="text-hide-mobile">Mon compte</span>
          <span class="icone"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
        </div>
      </div>
    </div>
  </div>

  <div class="main-nav">
    <div class="container container-desktop nav-content-distributed">
      <div class="logo-wrapper" [routerLink]="route.get('home')" style="cursor: pointer;">
        <img src="assets/img/logoGob.png" alt="Logo" class="logo">
      </div>

      <nav class="menu-items-distributed" *ngIf="!isAdmin">
        <span *ngIf="!menu" style="opacity: 0.5;">Chargement...</span>
        <ng-container *ngIf="menu">
          <div class="nav-item-wrapper" *ngFor="let item of menu" (mouseenter)="onMouseEnter(item.name)" (mouseleave)="onMouseLeave()">
              <a [routerLink]="getLink(item)" class="nav-pill">{{ item.name }}</a>
              <div class="menu-dropdown" *ngIf="hoveredCategory === item.name">
                 <gob-global-menu [parentItem]="item"></gob-global-menu>
              </div>
          </div>
        </ng-container>
      </nav>

      <nav class="menu-items-distributed" *ngIf="isAdmin">
         <div class="nav-item-wrapper dropdown" *ngIf="userServ.hasRight('orders') || userServ.hasRight('dashboard')" [class.open]="activeAdminMenu === 'orders'">
            <a class="nav-pill dropdown-toggle" (click)="toggleAdminMenu('orders', $event)">Commandes</a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" [routerLink]="route.get('my-order')">Mes commandes</a></li>
              <li *ngIf="userServ.hasRight('orders')"><a class="dropdown-item" [routerLink]="route.get('order-list')" [queryParams]="{admin: true}">Commandes client</a></li>
              <li *ngIf="userServ.hasRight('dashboard')"><a class="dropdown-item" [routerLink]="route.get('dashboard')">Dashboard</a></li>
            </ul>
          </div>
          <div class="nav-item-wrapper dropdown" *ngIf="userServ.hasRight('products')" [class.open]="activeAdminMenu === 'products'">
            <a class="nav-pill dropdown-toggle" (click)="toggleAdminMenu('products', $event)">Produits</a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" [routerLink]="route.get('product-list')">Produits</a></li>
              <li><a class="dropdown-item" [routerLink]="route.get('review-list')">Avis</a></li>
              <li><a class="dropdown-item" [routerLink]="route.get('class-list')">Classification</a></li>
            </ul>
          </div>
          <div class="nav-item-wrapper dropdown" *ngIf="userServ.hasRight('products')" [class.open]="activeAdminMenu === 'stocks'">
             <a class="nav-pill dropdown-toggle" (click)="toggleAdminMenu('stocks', $event)">Stocks</a>
             <ul class="dropdown-menu"><li><a class="dropdown-item" [routerLink]="route.get('depot-list')">Dépôts</a></li></ul>
          </div>
          <div class="nav-item-wrapper dropdown" *ngIf="userServ.hasRight('users') || userServ.hasRight('newsletters')" [class.open]="activeAdminMenu === 'users'">
            <a class="nav-pill dropdown-toggle" (click)="toggleAdminMenu('users', $event)">Utilisateurs</a>
            <ul class="dropdown-menu">
              <li *ngIf="userServ.hasRight('users')"><a class="dropdown-item" [routerLink]="route.get('user-list')">Utilisateurs</a></li>
              <li *ngIf="userServ.hasRight('users')"><a class="dropdown-item" [routerLink]="route.get('roles-list')">Rôles</a></li>
              <li *ngIf="userServ.hasRight('users')"><a class="dropdown-item" [routerLink]="route.get('group-list')">Groupes</a></li>
              <li *ngIf="userServ.hasRight('newsletters')"><a class="dropdown-item" [routerLink]="route.get('newsletters')">Newsletter</a></li>
            </ul>
          </div>
          <div class="nav-item-wrapper dropdown" *ngIf="userServ.hasRight('discounts') || userServ.hasRight('shippings') || userServ.hasRight('settings')" [class.open]="activeAdminMenu === 'params'">
            <a class="nav-pill dropdown-toggle" (click)="toggleAdminMenu('params', $event)">Paramètres</a>
            <ul class="dropdown-menu">
              <li *ngIf="userServ.hasRight('discounts')"><a class="dropdown-item" [routerLink]="route.get('promo-list')">Codes promo</a></li>
              <li *ngIf="userServ.hasRight('shippings')"><a class="dropdown-item" [routerLink]="route.get('shipper-list')">Livraisons</a></li>
              <li *ngIf="userServ.hasRight('settings')"><a class="dropdown-item" [routerLink]="route.get('settings')">Affichage</a></li>
              <li *ngIf="userServ.hasRight('settings')"><a class="dropdown-item" [routerLink]="route.get('menu')">Menu</a></li>
              <li *ngIf="userServ.hasRight('settings')"><a class="dropdown-item" [routerLink]="route.get('order-state-list')">Etat des commandes</a></li>
            </ul>
          </div>
          <div class="nav-item-wrapper"><a class="nav-pill" [routerLink]="route.get('my-account')">Mes infos</a></div>
          <div class="nav-item-wrapper"><a class="nav-pill" (click)="unlog()" style="background: #d32f2f;">Déconnexion</a></div>
      </nav>
    </div>
  </div>
  <div class="header-border"></div>
</header>

<div class="mobile-wrapper mobile-only">
  
  <header class="mobile-top-header">
    <div class="mobile-container">
      <div class="logo-mobile-wrapper" [routerLink]="route.get('home')">
        <img src="assets/img/logoGob.png" alt="Logo" class="logo-mobile">
      </div>
      <div class="mobile-actions">
        <div class="button-search-mob">
          <button (click)="basculerRecherche()">
            <span class="icon-wrapper" *ngIf="!rechercheMobileOuverte">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            </span>
            <span class="close-icon" *ngIf="rechercheMobileOuverte">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </span>
          </button>
        </div>
        <button class="burger-btn" (click)="toggleMenu()" [class.active]="isMenuOpen">
          <span class="bar"></span><span class="bar"></span><span class="bar"></span>
        </button>
      </div>
    </div>
  </header>

  <div class="search-wrapper-mobile">
      <app-search-bar [class.open]="rechercheMobileOuverte"></app-search-bar>
  </div>

  <div class="mobile-menu-overlay" [class.open]="isMenuOpen">
    <div class="menu-header">
      <span>{{ isAdmin ? 'Administration' : 'Menu' }}</span>
    </div>
    
    <nav class="mobile-menu-list">
      
      <ng-container *ngIf="!isAdmin">
        <div class="mobile-menu-item" *ngFor="let item of menu">
          
          <ng-container *ngIf="item.name.toLowerCase().includes('animation')">
            <div class="menu-row toggle-mode" (click)="toggleMobileCategory(item.name, $event)" [class.active]="activeMobileCategory === item.name">
              <span class="main-link">{{ item.name }}</span>
              <i class="fa-solid fa-chevron-down arrow-icon"></i>
            </div>
            <div class="sub-menu-container" [class.open]="activeMobileCategory === item.name">
              <div class="mobile-section-title">Nos cafés-jeux</div>
              <a *ngFor="let shop of dataShops" [href]="shop.lien" target="_blank" class="sub-link level-2">{{ shop.label }}</a>
              
              <div class="mobile-section-title">Nos tournois JCC</div>
              <a *ngFor="let tourney of dataTournaments" [href]="tourney.lien" target="_blank" class="sub-link level-2">{{ tourney.label }}</a>
              
              <div class="mobile-section-title">Nos activités</div>
              <a *ngFor="let act of dataActivities" [href]="act.lien" target="_blank" class="sub-link level-2">{{ act.label }}</a>
            </div>
          </ng-container>

          <ng-container *ngIf="!item.name.toLowerCase().includes('animation')">
            <div class="menu-row toggle-mode" 
                 *ngIf="item.children && item.children.length > 0"
                 (click)="toggleMobileCategory(item.name, $event)"
                 [class.active]="activeMobileCategory === item.name">
              <span class="main-link">{{ item.name }}</span>
              <i class="fa-solid fa-chevron-down arrow-icon"></i>
            </div>

            <div class="menu-row link-mode" *ngIf="!item.children || item.children.length === 0">
              <a [routerLink]="getLink(item)" (click)="closeMenu()" class="main-link full-click">
                {{ item.name }}
              </a>
            </div>

            <div class="sub-menu-container" 
                 *ngIf="item.children && item.children.length > 0"
                 [class.open]="activeMobileCategory === item.name">
              <ng-container *ngFor="let sub of item.children">
                <div class="mobile-section-title">{{ sub.name }}</div>
                <ng-container *ngIf="!sub.children || sub.children.length === 0">
                   <a [routerLink]="getLink(sub)" (click)="closeMenu()" class="sub-link level-2">{{ sub.name }}</a>
                </ng-container>
                <ng-container *ngIf="sub.children && sub.children.length > 0">
                  <a *ngFor="let deep of sub.children" [routerLink]="getLink(deep)" (click)="closeMenu()" class="sub-link level-2">
                     {{ deep.name }}
                  </a>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>

        </div>
      </ng-container>
      
      <ng-container *ngIf="isAdmin">
        <div class="mobile-section-title" *ngIf="userServ.hasRight('orders') || userServ.hasRight('dashboard')">Commandes</div>
        <ng-container *ngIf="userServ.hasRight('orders') || userServ.hasRight('dashboard')">
           <a [routerLink]="route.get('my-order')" (click)="closeMenu()">Mes commandes</a>
           <a *ngIf="userServ.hasRight('orders')" [routerLink]="route.get('order-list')" [queryParams]="{admin: true}" (click)="closeMenu()">Commandes client</a>
           <a *ngIf="userServ.hasRight('dashboard')" [routerLink]="route.get('dashboard')" (click)="closeMenu()">Dashboard</a>
        </ng-container>
        <div class="mobile-section-title" *ngIf="userServ.hasRight('products')">Produits & Stocks</div>
        <ng-container *ngIf="userServ.hasRight('products')">
           <a [routerLink]="route.get('product-list')" (click)="closeMenu()">Produits</a>
           <a [routerLink]="route.get('review-list')" (click)="closeMenu()">Avis</a>
           <a [routerLink]="route.get('class-list')" (click)="closeMenu()">Classification</a>
           <a [routerLink]="route.get('depot-list')" (click)="closeMenu()">Dépôts (Stocks)</a>
        </ng-container>
        <div class="mobile-section-title" *ngIf="userServ.hasRight('users')">Utilisateurs</div>
        <ng-container *ngIf="userServ.hasRight('users')">
           <a [routerLink]="route.get('user-list')" (click)="closeMenu()">Utilisateurs</a>
           <a [routerLink]="route.get('roles-list')" (click)="closeMenu()">Rôles</a>
           <a [routerLink]="route.get('group-list')" (click)="closeMenu()">Groupes</a>
           <a *ngIf="userServ.hasRight('newsletters')" [routerLink]="route.get('newsletters')" (click)="closeMenu()">Newsletter</a>
        </ng-container>
        <div class="mobile-section-title" *ngIf="userServ.hasRight('settings')">Paramètres</div>
        <ng-container *ngIf="userServ.hasRight('settings') || userServ.hasRight('discounts')">
           <a *ngIf="userServ.hasRight('discounts')" [routerLink]="route.get('promo-list')" (click)="closeMenu()">Codes promo</a>
           <a *ngIf="userServ.hasRight('shippings')" [routerLink]="route.get('shipper-list')" (click)="closeMenu()">Livraisons</a>
           <a *ngIf="userServ.hasRight('settings')" [routerLink]="route.get('settings')" (click)="closeMenu()">Affichage</a>
           <a *ngIf="userServ.hasRight('settings')" [routerLink]="route.get('menu')" (click)="closeMenu()">Menu</a>
           <a *ngIf="userServ.hasRight('settings')" [routerLink]="route.get('order-state-list')" (click)="closeMenu()">État commandes</a>
        </ng-container>
      </ng-container>

      <div class="menu-separator" *ngIf="isUserConnected()"></div>
      <a *ngIf="isUserConnected()" (click)="unlog(); closeMenu()" class="account-item logout" style="color: #d32f2f; font-weight: bold; padding: 15px 0 15px 20%;">Déconnexion</a>

    </nav>
  </div>

  <nav class="mobile-bottom-nav">
    <a [routerLink]="route.get('cart')" class="bottom-nav-item" routerLinkActive="active" (click)="closeMenu()">
      <div class="icon-wrapper">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
        </div>
        <span class="badge-white" *ngIf="cart.count() > 0">{{ cart.count() }}</span>
      </div>
      <span class="label">Mon panier</span>
    </a>

    <a [routerLink]="isUserConnected() ? route.get('admin-home') : route.get('login')" class="bottom-nav-item" routerLinkActive="active" (click)="closeMenu()">
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <span class="label">Mon compte</span>
    </a>
  </nav>
</div>